// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";  // Firebase 앱 초기화
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Firestore 서비스
import { getStorage } from "firebase/storage";    // Storage 서비스

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxzuwgyL6c3xrDBMxzawlGhpIRuAhsyxM",
  authDomain: "climbing-together.firebaseapp.com",
  projectId: "climbing-together",
  storageBucket: "climbing-together.firebasestorage.app",
  messagingSenderId: "421056982281",
  appId: "1:421056982281:web:1e6cfdb144b4dbcaf377d8",
  measurementId: "G-SJ2GHGM9E2"
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Firebase 서비스들 초기화
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };